import { GPSPosition } from '../GPS-position';

export class LocalisationStation {
    id: number;
    processId: number;
    avalId: number;
    amontId: number;

    Amont: GPSPosition = new GPSPosition();
    Aval: GPSPosition = new GPSPosition();
    LimiteAmont: string;
    LimiteAval: string;

    static mapFromJSON(json: any): LocalisationStation {
        const m = new LocalisationStation();

        m.LimiteAmont = json.limiteAmont;
        m.LimiteAval = json.limiteAval;

        if (json.amont) {
            m.Amont = GPSPosition.mapFromJSON(json.amont);
        }
        if (json.aval) {
            m.Aval = GPSPosition.mapFromJSON(json.aval);
        }

        return m;
    }
}
